var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "feature-tabs" },
    [
      _c("h5", [_vm._v("Feature assessments")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "features-buttons" },
        _vm._l(_vm.features, function (f) {
          return _c(
            "button",
            {
              attrs: {
                id: f.feature + "_btn",
                disabled: f.feature === _vm.activeTab,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.activeTab = f.feature
                },
              },
            },
            [_vm._v("\n            " + _vm._s(f.feature) + "\n        ")]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.features, function (f) {
        return f.feature === _vm.activeTab
          ? _c("div", [
              _c("p", [_c("strong", [_vm._v(_vm._s(f.feature))])]),
              _vm._v(" "),
              _c("p", [
                f.feature_GMA
                  ? _c("span", [
                      _vm._v(
                        "Feature General Management Approach (GMA): " +
                          _vm._s(f.feature_GMA)
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n            Feature designated:\n            "),
                f.feature_designation_date_as_text
                  ? _c("span", [
                      _vm._v(_vm._s(f.feature_designation_date_as_text)),
                    ])
                  : _c("span", [_vm._v("Unknown")]),
                _vm._v(".\n            "),
                _c("br"),
                _vm._v(
                  "\n            Most recent condition/vulnerability assessment:\n            "
                ),
                f.assessment_date_as_text
                  ? _c("span", [_vm._v(_vm._s(f.assessment_date_as_text))])
                  : _c("span", [_vm._v("Unknown")]),
                _vm._v(".\n            "),
                _c("br"),
                _vm._v(
                  "\n            Date site checked for this assessment: " +
                    _vm._s(f.date_site_checked_for_assessment) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                f.feature_condition_or_vulnerability_assessed
                  ? _c("span", [
                      _vm._v("Feature condition/vulnerability assessment "),
                      _c("strong", [_vm._v("is")]),
                      _vm._v(" available on SNCB website."),
                    ])
                  : _c("span", [
                      _vm._v("Feature condition/vulnerability assessment "),
                      _c("strong", [_vm._v("is not")]),
                      _vm._v(" available on SNCB website."),
                    ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                f.feature_in_jncc_classification &&
                f.feature_in_jncc_classification !== "N"
                  ? _c("span", [
                      _vm._v("Feature "),
                      _c("strong", [_vm._v("is")]),
                      _vm._v(
                        " included in JNCCs Marine Components Classification for SAC and SPAs."
                      ),
                    ])
                  : _c("span", [
                      _vm._v("Feature "),
                      _c("strong", [_vm._v("is not")]),
                      _vm._v(
                        " included in JNCCs Marine Components Classification for SAC and SPAs."
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n            Overall condition of the designated feature, where Statutory Nature Conservation Bodies report an overall result:\n            "
                ),
                _c("strong", [
                  f.overall_condition_vulnerability_result
                    ? _c("span", [
                        _vm._v(
                          _vm._s(f.overall_condition_vulnerability_result)
                        ),
                      ])
                    : _c("span", [_vm._v("Not reported by the SNCB")]),
                  _vm._v(".\n            "),
                ]),
                _vm._v(" "),
                f.confidence_in_assessment
                  ? _c("span", [
                      _c("br"),
                      _vm._v(
                        "\n                Overall confidence in this result, as reported by SNCB: " +
                          _vm._s(f.confidence_in_assessment) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("strong", [
                _vm._v(
                  "Percentage of the feature in each condition, where Statutory Nature Conservation Bodies report the condition in percentages:"
                ),
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "base-table" }, [
                _c("tr", [
                  _c("td", [
                    _vm._v("Percentage of the feature in Favourable condition"),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("prop_to_percent")(f.pct_favourable_condition)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      "Percentage of the feature in unfavourable recovering condition"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("prop_to_percent")(
                          f.pct_unfavourable_or_recovering_condition
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      "Percentage of the feature in unfavourable no change condition"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("prop_to_percent")(f.pct_unfavourable_no_change)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      "Percentage of the feature in unfavourable declining condition"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("prop_to_percent")(f.pct_unfavourable_declining)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      "Percentage of the feature in partially destroyed condition"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(
                        _vm._f("prop_to_percent")(f.pct_partially_destroyed)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _vm._v("Percentage of the feature in destroyed condition"),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(_vm._f("prop_to_percent")(f.pct_destroyed))),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      "Percentage of the feature which has not been condition assessed"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      _vm._s(_vm._f("prop_to_percent")(f.pct_not_assessed))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                f.link_to_condition_assessment
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          attrs: {
                            target: "_blank",
                            href: f.link_to_condition_assessment,
                          },
                        },
                        [_vm._v("Link to SNCB reported condition assessment.")]
                      ),
                      _vm._v(" "),
                      f.link_to_GMA ? _c("span", [_c("br")]) : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                f.link_to_GMA
                  ? _c("span", [
                      _c(
                        "a",
                        { attrs: { target: "_blank", href: f.link_to_GMA } },
                        [_vm._v("Link to SNCB reported GMA.")]
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              f.notes
                ? _c("p", [
                    _c("strong", [_vm._v("Notes")]),
                    _c("br"),
                    _vm._v("\n            " + _vm._s(f.notes) + "\n        "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [_vm._v(" ")]),
              _c("p", [_vm._v(" ")]),
              _c("p", [_vm._v(" ")]),
            ])
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }